import { ZfToggle } from '@zafire/react';
import type { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';
import { useRoadmapPageContext } from '../../contexts/roadmap-page-context';

export const CompletedEventsToggle: FunctionComponent = () => {
    const { t } = useTranslation();
    const { showCompletedEvents, setShowCompletedEvents } = useRoadmapPageContext();

    return (
        <ZfToggle
            style={{ paddingRight: '20px' }}
            label={t('showCompletedEvents')}
            checked={showCompletedEvents}
            onToggleChange={() => setShowCompletedEvents(!showCompletedEvents)}
        />
    );
};
